module.exports = __webpack_public_path__ + "img/Sending.2f41e2dd.png";